export default __webpack_public_path__ + "static/bahnschrift-b00e12e37c52124aa5044b8010c701f1.ttf";